import { observer } from 'mobx-react';
import { Participant } from '../../../../../../ParticipantsStore/Types';
import GroupsCell from './GroupsCell';
import LastLoginCell from './LastLoginCell';
import LicenseCell from './LicenseCell';
import PersonCell from './PersonCell';

interface Props {
  participant: Participant;
}

function Row({ participant }: Props) {
  return (
    <tr className="border-b border-border last:border-b-0">
      <td className="px-4 py-3">
        <PersonCell participant={participant} />
      </td>
      <td className="px-4 py-3">
        <GroupsCell groups={participant.userGroups} />
      </td>
      <td className="px-4 py-3">
        <LicenseCell licenses={participant.licenses} />
      </td>
      <td className="px-4 py-3">
        <LastLoginCell lastLoginAt={participant.lastLoginAt} />
      </td>
    </tr>
  );
}

export default observer(Row);
